<template>
    <div class="dough-nut-chart-wrap" style="position: relative">
        <div class="chart-data" v-if="data.chart">
            <div class="d-flex flex-wrap" style="padding: 30px 30px 0 30px">
                <div class="chart-title"
                     v-if="(data.chart && data.chart.title !== '') || (chartTitle && chartTitle !== '')">
                    {{ data.chart.title || chartTitle }}
                </div>
            </div>
            <div class="d-flex flex-wrap" style="padding: 30px;">
                <div style="flex: 1">
                    <div v-if="total > 0" class="dough-nut-chart-draw" style="width: 230px; height: 230px;">
                        <dough-nut-chart ref="chartContainer" :height="230" :width="230"></dough-nut-chart>
                        <span class="chart-label-center">
                            {{ $f.addDotToNumber(data.data[data.chart.primary]['value'])}}
                        </span>
                    </div>
                    <div v-else class="empty-circle">0</div>
                </div>
                <div style="width: 130px; margin-left: 20px">
                    <table class="chart-desc" v-if="!hideDesc">
                        <tr v-for="(item, index) in data.chart.secondary" :key="index">
                            <td>
                                <span
                                    :style="'background: '+ data.data[item]['color'] || chartColors[index]"
                                    class="cube-color"></span>
                            </td>
                            <td>{{ data.data[item]['title'] }}</td>
                            <td>{{ data.data[item]['value'] }}</td>
                        </tr>
                    </table>
                </div>
            </div>
            <div class="btn-icon btn-info-chart">
                <v-icon color="#96ADD0">mdi-information</v-icon>
            </div>
            <div class="info-chart">
                <table class="additional-data"
                       :class="{'no-additional-title' : !data.chart.subTitle && !additionalHeader}"
                       v-if="showTable">
                    <tbody>
                    <tr v-for="(item, index) in data.data" :key="index">
                        <td>{{ item.title }}</td>
                        <td><b>{{ item.value }}</b></td>
                        <td><b>{{ total === 0 ? 0 : Math.round(item.value / total * 1000) / 10 }}%</b></td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>
<script>
import VueCharts from 'vue-chartjs'
import * as _ from 'lodash'

export default {
    name: 'DoughNutChartCustom',
    components: {
        DoughNutChart: VueCharts.Doughnut
    },
    props: {
        data: {
            type: Object,
            default: () => ({}),
            required: true
        },
        chartTitle: String,
        hideDesc: Boolean,
        additionalHeader: String,
        colors: Array,
        showTable: Boolean,
        unit: String
    },
    data() {
        return {
            labels: [],
            chartContainer: false,
            chartColors: this.$utils.colorSamples,
            total: 1
        }
    },
    mounted() {
        if (this.colors) {
            this.chartColors = [this.colors, ...this.chartColors]
        }
        this.renderChart()
    },
    methods: {
        renderChart() {
            let unit = this.unit
            let chartData = []
            let colorData = []
            if (!this.data.chart) {
                return
            }
            let total = parseInt(this.data.data[this.data.chart.primary]['value']) || null
            this.total = total
            if (total && total < 1) {
                return
            }
            this.data.chart.secondary.map((item, idx) => {
                chartData.push(this.data.data[item]['value'])
                let color = this.data.data[item]['color']
                if (color && color !== '') {
                    colorData.push(color)
                } else {
                    colorData.push(this.chartColors[idx])
                }
            })
            this.labels = []
            chartData.map(item => {
                let percent = (item / total) * 100
                this.labels.push(_.round(percent, 1))
            })
            let genDatasets = () => {
                return [
                    {
                        data: chartData,
                        backgroundColor: colorData,
                        label: 'Dataset 1'
                    }
                ]
            }
            let datasets = genDatasets()
            this.chartContainer = datasets
            const render = () => {
                if (!this.$refs.chartContainer) {
                    setTimeout(render, 100)
                    return
                }
                this.$refs.chartContainer.renderChart({
                    labels: this.labels,
                    datasets: datasets
                }, {
                    responsive: true,
                    maintainAspectRatio: false,
                    cutoutPercentage: 75,
                    hover: {
                        mode: 'nearest',
                        intersect: true
                    },
                    legend: {
                        display: false
                    },
                    tooltips: {
                        enabled: true,
                        callbacks: {
                            title: (tooltipItems, data) => {
                                let hexColor = data['datasets'][0].backgroundColor[tooltipItems[0]['index']]
                                let nameType = ''
                                for (const property in this.data.data) {
                                    if (this.data.data[property]['color'] === hexColor) {
                                        nameType = this.data.data[property]['title']
                                    }
                                }
                                return nameType + ': ' + data['labels'][tooltipItems[0]['index']] + '%'
                            },
                            label: function (tooltipItem, data) {
                                return data['datasets'][0]['data'][tooltipItem['index']] + ' ' + unit
                            },
                        },
                        backgroundColor: '#000',
                        titleFontSize: 16,
                        titleFontColor: '#FFF',
                        bodyFontColor: '#FFF',
                        bodyFontSize: 14,
                        xPadding: 12,
                        yPadding: 12
                    },
                    elements: {
                        arc: {
                            borderWidth: 0
                        }
                    },
                    plugins: {
                        datalabels: {
                            display: false
                        }
                    }
                })
            }
            render()
        }
    },
    watch: {
        data() {
            this.renderChart()
        }
    }
}
</script>
<style scoped lang="scss">
.empty-circle {
    width: 230px;
    height: 230px;
    border-radius: 50%;
    border: 1px solid #e0e1e2;
    font-size: 20px;
    font-weight: 700;
    display: flex;
    align-items: center;
    justify-content: center;
}

.btn-info-chart {
    position: absolute;
    top: 30px;
    right: 30px;


    &:hover ~ .info-chart {
        visibility: visible;
    }
}

.select-option-limit {
    position: absolute;
    top: 36px;
    right: 70px;
}

.info-chart {
    position: absolute;
    top: 65px;
    right: 35px;
    border: 1px solid #e4edfa;
    background: #fff;
    font-size: 14px;
    padding: 12px;
    border-radius: 5px;
    visibility: hidden;
}

.dough-nut-chart-wrap {
    border-radius: 5px !important;
    border: 1px solid #D9D9D9 !important;
}
</style>
